import { render, staticRenderFns } from "./ComboboxFormaPagamento.vue?vue&type=template&id=7f00b0d0&"
import script from "./ComboboxFormaPagamento.vue?vue&type=script&lang=js&"
export * from "./ComboboxFormaPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCard,VCombobox})
